import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-consistencycorner-couch-pinkcamo.jpg`;
const ALT = "Lara sitting on a couch writing in her notebook, laptop resting nearby.";

const examples = [
  "A project you want to finish",
  "A habit you\u2019re trying to rebuild",
  "A decision you\u2019re ready to make",
  "A dream that keeps getting postponed",
  "A promise you want to keep to yourself",
];

export function WhatYouCanBring() {
  return (
    <section data-testid="cc-what-you-bring-section" className="relative overflow-hidden bg-white">
      <div className="relative w-full overflow-hidden reveal pb-[46px] lg:pb-0">
        {/* Desktop: tighter, focused crop half-band on the right */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[36%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-what-you-bring-image"
            bg="#FFFFFF"
            objectPosition="55% 18%"
            featherLeft={48}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile: stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/3] mb-[30px]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="cc-what-you-bring-image-mobile"
            bg="#FFFFFF"
            objectPosition="55% 12%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 lg:min-h-[560px] flex items-center">
          <div className="w-full lg:w-[62%] lg:pr-10">
            <h2 className="font-display text-4xl md:text-5xl lg:text-[52px] leading-[1.1] tracking-tight text-[#1C1917] mb-7 max-w-lg">
              Bring the thing you keep meaning to return to.
            </h2>
            <div className="space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-[553px] mb-8">
              <p>
                It might be a business idea, a creative project, a healthier
                habit or a conversation you&rsquo;ve been avoiding.
              </p>
              <p>
                It might be paperwork, writing, planning, healing or making
                space for a part of yourself that keeps getting pushed aside.
              </p>
              <p>It doesn&rsquo;t have to look important to anyone else.</p>
              <p className="text-[#159E9A] font-display text-xl md:text-2xl">
                It only has to matter to you.
              </p>
            </div>

            <ul className="space-y-3 max-w-md">
              {examples.map((ex) => (
                <li
                  key={ex}
                  data-testid={`cc-example-${ex.slice(0, 8).replace(/\s+/g, "-").toLowerCase()}`}
                  className="flex items-baseline gap-3 text-base md:text-lg text-[#1C1917]"
                >
                  <span aria-hidden className="text-[#F6A041]">&ndash;</span>
                  <span>{ex}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
